var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"transition"},[_c('div',{staticClass:"text",style:(("--maxHeight: " + _vm.maxHeight))},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }